<template>
<div id="detailContrastTableTwo">
  <h2>{{$t('avatamsaka.levelThree.example')}}</h2>

    <tr><td>一、</td><td>
      《藏、漢〈華嚴經・淨行品〉五異譯校勘本》(簡稱《校勘本》)是根據藏、 漢譯《華嚴經・淨行品》
      五個異譯本所進行的校勘成果。這五個異譯本分別是支讖譯
      《諸菩薩求佛本業經》(簡稱《求佛》)、支謙譯
      《菩薩本業經・願行品》(簡稱《本業》)、佛陀跋陀羅譯
      《六十華嚴・淨行品》(簡稱《六 十》)、實叉難陀譯《八十華嚴・淨行品》(簡稱《八十》)以及
       Jinamitra、 Surendrabodhi 和 ཡེ་ཤེས་སེ
        翻譯的藏譯《華嚴經・淨行品》(簡稱《藏譯》)(依翻譯年代排序)。
    </td></tr>
    <tr><td>二、</td><td>
      本《校勘本》採用台灣教育部研訂的標準字體和新式標點。
    </td></tr>
    <tr><td>三、</td><td>
      《藏譯》校勘涉及十個版本，以《中華大藏經・甘珠爾》(對勘本)(簡稱 M)為底本，
      對校 ཐེམས་སྤང་མ 系譜的朵宮(Stog)《甘珠爾》寫本(簡稱 S)和隸屬獨立系譜的普扎
      (Phug brag)《甘珠爾》寫本(簡稱 F)，以期呈現比較完整藏譯版本的面貌。M
      對勘本採用的八個版本包括隸屬 ཚལ་པ 傳承的永樂版(簡稱 Y)、理塘版(簡稱 J)、北京版(簡稱 Q)、
      卓尼版(簡稱 C)、 德格版(簡稱 D)和庫倫版(簡稱 U)以及被歸類為混合版本的納塘版(簡 稱 N)和拉薩版(簡稱 H)，
      以公認品質優良的 D 為底本。
    </td></tr>
    <tr><td>四、</td><td>
      《求佛》、《本業》、《六十》和《八十》主要以《大正新修大藏經》校勘本 (簡稱《大》)為底本。《求佛》、
      《六十》和《八十》各對校《高麗藏》(簡 稱《高》)和《宋版磧砂大藏經》(簡稱《磧》)兩個輔本，
      而《本業》則對校《敦煌寶藏》(簡稱《敦》)、
      《高》和《磧》三個輔本。以下列出《求佛》、 《本業》、《六十》和《八十》各自校勘所涉及的版本：
      <tr><td>(一)</td><td>《求佛》-《聖》t、《高》、《宮》t、《宋》t、《磧》、《元》t、《明》t、《大》
      </td></tr><tr><td>(二)</td><td>《本業》-《聖》t、《聖乙》t、《敦》、《高》、《宮》t、
        《宋》t、《磧》、《元》t、《明》t、《大》
      </td></tr><tr><td>(三)</td><td>《六十》-《聖》t、《高》、《宮》t、《宋》t、《磧》、《元》t、《明》t、《大》
      </td></tr><tr><td>(四)</td><td>《八十》-《高》、《宮》t、《宋》t、《磧》、《元》t、《明》t、《大》
      </td></tr>
    </td></tr>
    <tr><td>五、</td><td>
      《求佛》底本所參考的《聖》為《聖語藏・景雲經》第四八號，神護景雲 二年(768)寫，孝謙天皇御願。
      《本業》底本所參考的《聖》為《聖語藏・願經》第二七號，天平十二年(740)寫，
      光明皇后御願，而《聖乙》則為
      《聖語藏・景雲經》第一 O 五號，神護景雲二年(768)寫，孝謙天皇御願。
      《六十》底本所參考的《聖》為
      《聖語藏・景雲經》第一 O 號，神護景雲 二年(768)寫，孝謙天皇御願。
    </td></tr>
    <tr><td>六、</td><td>
      校勘原則以異文或異體字為主，除了在校勘注中列出底本或輔本的訛誤、脫文、衍文等差異現象，
      也按語說明校訂異文的相關依據。
    </td></tr>
    <tr><td>七、</td><td>
      本校勘注收錄 M 和《大》的校勘成果，分別以「M」和「t」來標示引用自 M 和《大》
      的版本異文記錄，編者均未親眼確認，其他則是編者親自校勘的內容。另外，M
       校勘注未列出異文對應的底本內容，編者在校勘注一一補上。
    </td></tr>
    <tr><td>八、</td><td>
      以下是編者處理藏、漢譯字體的原則:
      <tr><td>(一)</td><td>針對《藏譯》屬於語詞拼寫的差異現象，編者僅校訂影響解讀的異文。
      另外，編者一致將版本的古字(བརྡ་རྙིང)調整為現代寫法，以利於讀者 搜尋、查找，
      但在校勘注中保留各個版本的古字記錄，方便有興趣者參考。</td>
      </tr><tr><td>(二)</td><td>《求佛》、《本業》、《六十》和《八十》
      皆出現大量的異體字(即與正字同音、義而異形者)。
      編者在校勘注中只列出可能造成解讀困擾之異 體字，其他徑改成正體字，不出校。如下:</td></tr>
      <div class="quote">
         「本」，《敦》和《高》作「夲」。「夲」可為「本」和「夵」之異體字，此為前者。
      </div>
    </td></tr>
    <tr><td>九、</td><td>
      本《校勘本》的引用格式：
      <tr>
      <td>(一)</td><td>編者在引用漢譯本經文時，依次標出藏經略符、冊碼、經號、頁碼、
      欄次、行碼，如 T 09.278.431 a 07。此處 T 是依據 cBeta 對《大》的標記方式。
      M 的版面與傳統藏經不同，
      所以引用時依次標出藏經略符、 冊碼、經號、頁碼、行碼，如 M 35.61.478.07。
      </td>
      </tr>
      <tr>
      <td>(二)</td><td>編者在引用《藏漢大辭典》(簡稱《藏漢》)時，
        依次標出頁碼和欄次， 而在引用《梵藏漢和四譯對校飜譯名義大集》
        (簡稱 Mvyt)時，則標出術語的號碼。
      </td>
      </tr>
    </td></tr>
    <tr><td>十、</td><td>
      編者親自標點經文，並且將經文分成三個主要段落，以 1、2 和 3 依序標記，
      經題等資料的段落則以 0 標示，如下:
      <br/>0. 經題、卷數、譯者、品名
      <br/>1. 智首菩薩提問
      <br/>2. 文殊菩薩總答
      <br/>3. 文殊菩薩別答
    </td></tr>
    <tr><td>十一、</td><td>
      每個段落依其主題斷句，而每個句子都以數字編排、標記。譬如 3.56，
      即第三段第五十六句。第三段經文每個句子的句尾都會標示該句在各 自譯本的序數。
      由於《八十》第三段經文所含的句子數量最多，共 141
      句，所以句首的編號以《八十》句子的編號為主。
    </td></tr>

</div>
</template>

<script>
export default {
  name: 'detailContrastTableTwo',
};
</script>
<style lang="scss" scoped>

#detailContrastTableTwo {
  > tr {
    > td:first-child {
        width: 4em;
        text-align: right;
      }
    > td {
      text-align: left;
      list-style-type: cjk-ideographic;
      padding-left: 1em;
      padding-top: 2em;
      >tr {
        td:first-child {
          width: 2em;
        }
      }
      .quote {
        border: 1px solid rgba(61, 106, 84, 0.9);
      }
    }
  }
  @media (max-width: 768px) {
    margin: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DetailContrastTableTwo.vue